/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.woocommerce-product-gallery__nav-slider figure' ).slick( {
        arrows: false,
        dots: false,
        slidesToShow: 1,
        infinite: false,
        asNavFor: $( '.woocommerce-product-gallery__main-slider figure' )[0],
      } );

      $( '.woocommerce-product-gallery__main-slider figure' ).slick( {
        arrows: true,
        dots: false,
        slidesToShow: 4,
        infinite: false,
        focusOnSelect: true,
        prevArrow: $( '.woocommerce-product-gallery__prev-slide' )[0],
        nextArrow: $( '.woocommerce-product-gallery__next-slide' )[0],
        asNavFor: $( '.woocommerce-product-gallery__nav-slider figure' )[0],
      } );

      $( '.woocommerce-product-gallery__nav-slider' ).magnificPopup( {
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'shop', COMPONENT );
} )( app );
